var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4V13H0V4H3ZM3 1.49948C3 2.33303 2.42091 3 1.49108 3H1.47404C0.578773 3 0 2.33303 0 1.49948C0 0.648306 0.5964 0 1.50865 0C2.42091 0 2.98269 0.648306 3 1.49948ZM13 7.95797L12.9999 12.9998H10.0519V8.29535C10.0519 7.11371 9.62535 6.30738 8.55814 6.30738C7.74368 6.30738 7.25855 6.85096 7.04549 7.37598C6.96754 7.56414 6.94841 7.8263 6.94841 8.08911V13H4C4 13 4.03886 5.03183 4 4.20672H6.94841V5.45221C7.33968 4.85348 8.04046 4 9.60568 4C11.5456 4 13 5.25705 13 7.95797Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin_logo.a08cdabe7e97aad72c954d083ae86f1f.svg";
export { ForwardRef as ReactComponent };